module.exports = __webpack_public_path__ + "static/media/Notice Blue V2-03.7aac4aee.svg";